// extracted by mini-css-extract-plugin
export default {"root":"root--k1wBE","header":"header--XvL6z","left":"left--MUjCW","dialogWrapper":"dialogWrapper--ygEZa"};